import createCrudModel, { CrudModel } from '../../common/crud-model/crud.model';
import FederatedDomain from '../../types/federated-domain';

export type FederatedDomainModel = CrudModel<FederatedDomain>;
const federatedDomainModel: FederatedDomainModel = createCrudModel<FederatedDomain>(
  '/api/federated-domains',
);

export default federatedDomainModel;
